module.exports = __webpack_public_path__ + "VIPV16.png?ad147dc4af0b71d62f41bb051514e349";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/horses/VIPV16.png
// module id = 110
// module chunks = 0